(function () {
  'use strict';
  function init() {
    var bar = document.querySelector('.sr-sticky-buy');
    if (!bar || bar.dataset.initialized) return;
    bar.dataset.initialized = 'true';
    var button = bar.querySelector('.sr-sticky-buy__atc');
    var label = bar.querySelector('.sr-sticky-buy__atc-label');
    var price = bar.querySelector('.sr-sticky-buy__price');
    var terms = bar.querySelector('[data-sr-sticky-terms]');
    var footer = document.querySelector('body > footer');
    var frame = null;
    var observedTarget = null;
    var observer = typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver(schedule);
    function mainButton() { return document.querySelector('.product-information .add-to-cart-button'); }
    function keyboardOpen() {
      var active = document.activeElement;
      return active && active.matches('textarea, input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"])');
    }
    function setText(el, text) { if (el.textContent !== text) el.textContent = text; }
    function update() {
      frame = null;
      var target = mainButton();
      if (!target) { bar.hidden = true; return; }
      if (observer && observedTarget !== target) {
        if (observedTarget) observer.unobserve(observedTarget);
        observedTarget = target;
        observer.observe(target);
      }
      var rect = target.getBoundingClientRect();
      var before = rect.bottom > window.innerHeight;
      var after = rect.top < 0;
      var footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
      var dialogOpen = document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]');
      // Top-tier pattern (2026-10-07 research): stay visible until the footer; forms on screen do not hide
      // the bar, only an open keyboard does (same rule as the welcome offer since 2026-10-06).
      var show = (before || after) && !footerVisible && !keyboardOpen() && !dialogOpen;
      // Write only what changed: identical writes still dirty layout and slow the next tap (INP).
      if (bar.hidden !== !show) bar.hidden = !show;
      bar.classList.toggle('is-visible', show);
      if (bar.dataset.action !== 'add') bar.dataset.action = 'add';
      if (button.disabled !== target.disabled) button.disabled = target.disabled;
      setText(label, button.disabled ? bar.dataset.soldOutLabel : bar.dataset.addLabel);
      if (button.dataset.srTrack !== 'sticky_add_to_cart_click') button.dataset.srTrack = 'sticky_add_to_cart_click';
      var currentPrice = document.querySelector('.product-information product-price .price');
      if (currentPrice && currentPrice.textContent.trim()) setText(price, currentPrice.textContent.trim());
      // Mirror Shop Pay's own monthly figure (never computed here) so the bar shows the same number as the price block.
      if (terms) {
        var paymentTerms = document.querySelector('.product-information shopify-payment-terms');
        var match = paymentTerms && paymentTerms.shadowRoot && (paymentTerms.shadowRoot.textContent || '').match(/\$[\d,]+(?:\.\d{2})?\/mo/);
        var termsText = match ? 'or ' + match[0] : '';
        setText(terms, termsText);
        if (terms.hidden !== !termsText) terms.hidden = !termsText;
      }
      placeChat();
    }
    // Shopify Inbox: keep the chat activator off the purchase controls (sticky bar, the inline
    // Add to cart button) and off a Klaviyo bottom flyout. Uses Inbox's own documented hook,
    // the --shopify-chat-activator-offset custom property on <shopify-chat>; the chat is never hidden.
    var CHAT_BASE = 20;
    var CHAT_GAP = 12;
    var cachedActivator = null;
    function chatGuards() {
      var list = [];
      if (!bar.hidden) list.push(bar);
      var target = mainButton();
      if (target) list.push(target);
      document.querySelectorAll('[role="dialog"][aria-label$="Form" i], .kl-private-reset-css-Xuajs1[role="dialog"]').forEach(function (el) {
        var cs = el.getClientRects().length && getComputedStyle(el);
        if (cs && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05) list.push(el);
      });
      return list;
    }
    // Inbox renders either <shopify-chat> > button[part=activator] or a nested
    // <shopify-agent-runtime exportparts="activator"> with its own shadow root.
    function findActivator(root) {
      var direct = root.querySelector('[part~="activator"]');
      if (direct) return direct;
      var nodes = root.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].shadowRoot) {
          var found = findActivator(nodes[i].shadowRoot);
          if (found) return found;
        }
      }
      return null;
    }
    // Mobile: hide the floating activator while the main buy area (variant picker through Add to cart)
    // is on screen; it returns once that area scrolls out. Never while chat is open or after a
    // theme link opened it (window.solisOpenChat sets data-sr-chat-used).
    var buyAreaVisible = new Map();
    var buyAreaObserver = typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { buyAreaVisible.set(entry.target, entry.isIntersecting); });
      schedule();
    });
    function watchBuyArea() {
      if (!buyAreaObserver) return;
      document.querySelectorAll('.product-information variant-picker, .product-information .buy-buttons-block').forEach(function (el) {
        if (!buyAreaVisible.has(el)) { buyAreaVisible.set(el, false); buyAreaObserver.observe(el); }
      });
    }
    function buyAreaOnScreen() {
      var on = false;
      buyAreaVisible.forEach(function (visible, el) { if (visible && el.isConnected) on = true; });
      return on;
    }
    function yieldChat(chat, activator) {
      var expanded = activator && activator.getAttribute('aria-expanded') === 'true';
      var hide = window.innerWidth < 750 && buyAreaOnScreen() && !chat.hasAttribute('open') && !expanded && !chat.dataset.srChatUsed;
      chat.classList.toggle('sr-chat-yield', hide);
    }
    function placeChat() {
      var chat = document.querySelector('shopify-chat');
      watchBuyArea();
      if (!chat) return;
      if (chat.hasAttribute('open')) { chat.classList.remove('sr-chat-yield'); return; }
      if (!cachedActivator || !cachedActivator.isConnected) cachedActivator = chat.shadowRoot && findActivator(chat.shadowRoot);
      var activator = cachedActivator;
      yieldChat(chat, activator);
      if (!activator) return;
      var rect = activator.getBoundingClientRect();
      if (!rect.width) return;
      var current = parseFloat(chat.style.getPropertyValue('--shopify-chat-activator-offset')) || CHAT_BASE;
      // Where the activator sits at Inbox's default offset.
      var restBottom = rect.bottom + (current - CHAT_BASE);
      var restTop = restBottom - rect.height;
      var offset = CHAT_BASE;
      chatGuards().forEach(function (el) {
        var g = el.getBoundingClientRect();
        if (!g.width || !g.height) return;
        var overlapsX = g.left < rect.right + 4 && g.right > rect.left - 4;
        var overlapsY = g.top < restBottom + 4 && g.bottom > restTop - CHAT_GAP;
        if (overlapsX && overlapsY) offset = Math.max(offset, CHAT_BASE + (restBottom - g.top) + CHAT_GAP);
      });
      offset = Math.round(Math.min(offset, window.innerHeight * 0.6));
      if (offset === CHAT_BASE) {
        if (chat.style.getPropertyValue('--shopify-chat-activator-offset')) chat.style.removeProperty('--shopify-chat-activator-offset');
      } else if (Math.abs(offset - current) > 1) {
        chat.style.setProperty('--shopify-chat-activator-offset', offset + 'px');
      }
    }
    // Run just after the next paint, not before it: this is bookkeeping, and doing its layout reads
    // inside the frame that answers a tap delayed that tap's visual response (INP). Layout is clean
    // right after a paint, so the reads here are cheap.
    function schedule() {
      if (frame !== null) return;
      frame = requestAnimationFrame(function () { setTimeout(update, 0); });
    }
    button.addEventListener('click', function () {
      var target = mainButton();
      if (!target) return;
      if (!target.disabled) target.click();
    });
    document.addEventListener('variant:update', function (event) {
      var source = event.target;
      if (source?.closest?.('quick-add-component, swatches-variant-picker-component, dialog')) return;
      var productId = event.detail?.data?.productId;
      if (productId && String(productId) !== bar.dataset.productId) return;
      var variant = event.detail?.resource;
      if (variant && typeof variant.price === 'number') {
        var currency = window.Shopify?.currency?.active || 'USD';
        price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: currency, minimumFractionDigits: variant.price % 100 ? 2 : 0, maximumFractionDigits: 2}).format(variant.price / 100);
        document.querySelectorAll('.product-information .sr-atc-price').forEach(function (el) { el.textContent = ' · ' + price.textContent; });
      }
      requestAnimationFrame(schedule);
    });
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    window.visualViewport?.addEventListener('resize', schedule, {passive: true});
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    document.addEventListener('toggle', schedule, true);
    document.addEventListener('close', schedule, true);
    var mutations = new MutationObserver(schedule);
    mutations.observe(document.querySelector('main'), {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-busy', 'hidden']});
    if (observer && footer) observer.observe(footer);
    // Inbox and Klaviyo mount their widgets as direct children of <body>; a Klaviyo flyout
    // closes on click, so re-check shortly after any click.
    new MutationObserver(schedule).observe(document.body, {childList: true});
    document.addEventListener('click', function () { setTimeout(schedule, 450); }, true);
    schedule();
    // Shop Pay renders its monthly figure asynchronously inside a shadow root that MutationObserver cannot see.
    setTimeout(schedule, 1500);
    setTimeout(schedule, 4000);
    setTimeout(schedule, 8000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
